import { Box, Button, Card } from '@material-ui/core';
import { useDataProvider, useNotify } from 'ra-core';
import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TabbedForm, FormTab, useRefresh } from 'react-admin';
import { setFreeTickets } from '../../redux/actions/propertyActions';
import { checkFreeTicketsError } from '../../helpers/checkfFreeTickets';
import LandingFreeTickets from '../common/landingFreeTickets';

const GeneralFreeTickets = (props: any) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const stateApp = useSelector((state) => state);
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const FreeTicketsToolbar = () => {
    const saveChanges = async () => {
      const data = {
        freeTicketsRates: stateApp.property.freeTickets.freeTicketsRates,
        isFreeTicketsRates: true,
      };
      const freeTicketsError = checkFreeTicketsError(data.freeTicketsRates);
      if (freeTicketsError) {
        notify('The form is not valid. Please check for errors', 'error');
        return;
      }
      // dispatch(setFreeTickets({ freeTicketsRates: [], isActive: false }));
      const result = await dataProvider.updateLandingGeneral(props.pageType, {
        data: data,
        previousData: {} as any,
      });
      if (!result.data) {
        notify('something went wrong', 'error');
      }
      notify(`Free tickets successfully update`);
      refresh();
    };
    return (
      <Box>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={saveChanges}
        >
          Save
        </Button>
      </Box>
    );
  };

  return (
    <Card
      component='div'
      className='tabCardWrapper creditsTabLayout user-toolbar'
      id='general-tabs-form'
    >
      <TabbedForm className='free-tickets-tabs' toolbar={FreeTicketsToolbar()}>
        <FormTab label='Dream home'>
          <LandingFreeTickets isGeneral={true} pageType={props.pageType} />
        </FormTab>
      </TabbedForm>
    </Card>
  );
};

export default GeneralFreeTickets;
